import { Subscription } from 'rxjs';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { StorageHlp } from 'src/lib/fliko/helpers/storage.helper';
import { UserHlp } from 'src/lib/fliko/helpers/user.helper';
import { TenancyAgreementData } from 'src/lib/fliko/models/agreements/tenancyAgr.data';
import { NoteType } from 'src/lib/fliko/models/notes/notes.data';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { FileInStorageVM } from 'src/app/shared/models/file.data';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
// eslint-disable-next-line max-len
import { UsersPrsAgreementArchiveComponent } from '../../../components/prs/users-prs-agreement-archive/users-prs-agreement-archive.component';
import { ResidentsListBuilder } from '../../../helpers/resident-list-builder';
import { UserPRSList } from '../../../services/models/users-table.data';
import { UnitResidentViewModel } from '../../../services/models/users-view-models';

@Component({
  selector: 'app-users-prs-agreement-details',
  templateUrl: './users-prs-agreement-details.component.html',
  styleUrls: ['./users-prs-agreement-details.component.scss']
})
export class UsersPrsAgreementDetailsComponent implements OnInit, OnDestroy {
  public residents: UnitResidentViewModel[] = [];
  public isArchiveAgreement = false;
  public canEdit = false;

  public agreement: TenancyAgreementData;
  public attachments: FileInStorageVM[] = [];

  private subscription$ = new Subscription();

  RentalUnitType = RentalUnitType;
  NoteType = NoteType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserPRSList.AgreementElement,
    private dialogRef: MatDialogRef<UsersPrsAgreementDetailsComponent>,
    private dialog: MatDialog,
    private router: Router,
    private ctxDS: ContextDataService
  ) {
    this.residents = ResidentsListBuilder.forPRS(data);
    this.agreement = data.agreement;
    this.isArchiveAgreement = UserHlp.isArchivedAgreement(data.agreement);
  }

  ngOnInit(): void {
    this.attachments =
      this.agreement.attachments?.map((a) => {
        return { storagePath: a, name: StorageHlp.pathToName(a) };
      }) ?? [];

    this.subscription$.add(
      this.ctxDS.contextPerms$.subscribe((perms) => (this.canEdit = perms?.superAdmin || !!perms?.ePerm?.user?.edit))
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public onEdit(): void {
    if (!this.canEdit) return;
    this.router.navigate(['/users/agreements', this.data.agreement.id]);
    this.dialogRef.close();
  }

  public onArchive(): void {
    if (!this.canEdit) return;

    const dialog = this.dialog.open(UsersPrsAgreementArchiveComponent, {
      maxHeight: '90vh',
      width: '600px',
      maxWidth: '60vw',
      data: this.agreement
    });
    dialog.afterClosed().subscribe((data) => {
      if (data?.agreement) {
        this.agreement = data.agreement;
        this.isArchiveAgreement = UserHlp.isArchivedAgreement(data.agreement);
      }
    });
  }
}
